(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/picasso/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/picasso/assets/javascripts/prescript.js');
"use strict";


svs.numbergames.picasso = svs.numbergames.picasso || {};
svs.numbergames.picasso.setup = svs.numbergames.picasso.setup || {};
svs.numbergames.picasso.image = svs.numbergames.picasso.image || {};
svs.numbergames.picasso.image_multi = svs.numbergames.picasso.image_multi || {};

 })(window);